import React from "react"

import { AlertTriangle, CheckCircle2, FileText, Hash } from "lucide-react"

interface FormHeaderProps {
  trialId: string
  trialResult: string
}

const FormHeader: React.FC<FormHeaderProps> = ({ trialId, trialResult }) => {
  const isPassed = trialResult === "Passed"

  return (
    <div className="bg-palette-jungleGreen000 p-6 rounded-lg mb-6 border">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <FileText className="h-6 w-6 text-palette-jungleGreen600" />
          <h2 className="text-2xl font-bold text-palette-jungleGreen900">Trial Block Review</h2>
        </div>

        {/* Redesigned Trial Result Section - Removed "Trial Result" text */}
        <div className="flex flex-col items-end gap-2">
          <div
            className={`flex items-center gap-2 px-4 py-2 rounded-full font-semibold text-lg ${
              isPassed
                ? "bg-green-100 text-green-800 border-2 border-green-200"
                : "bg-red-100 text-red-800 border-2 border-red-200"
            }`}
          >
            {isPassed ? (
              <CheckCircle2 className="h-5 w-5 text-green-600" />
            ) : (
              <AlertTriangle className="h-5 w-5 text-red-600" />
            )}
            <span>{trialResult}</span>
          </div>
        </div>
      </div>

      <div className="flex items-center pt-4 border-t border-palette-jungleGreen200">
        <Hash className="h-4 w-4 text-palette-jungleGreen500 mr-2" />
        <span className="text-sm font-medium text-palette-jungleGreen700">Trial ID:</span>
        <span className="ml-2 text-sm text-palette-jungleGreen600 font-mono">{trialId}</span>
      </div>
    </div>
  )
}

export default FormHeader
